<!-- Header -->
<h1 class="py-3">
    <i class="{{data.icon ? data.icon : 'fa fa-info-circle'}} d-block pb-3"></i> {{data.title | translate}}
</h1>
<button type="button" class="close-button" (click)="close()">&times;</button>

<!-- Message -->
<p>{{data.message | translate}}</p>

<!-- Options -->
<div>
    <mat-radio-group aria-labelledby="options-radio-group-label" class="options-radio-group"
        (change)="selectedOption = $event.value">
        <mat-radio-button class="options-radio-button ui-overflow" *ngFor="let option of data.options; let pos = index;"
            [value]="option" [color]="'primary'" [checked]="data.selected == option.id || data.selected == option">
            <i class="{{option.icon}} pr-1"></i>
            <span title="{{option.title | translate}}">{{(option.title ? option.title : option) | translate}}</span>
        </mat-radio-button>
    </mat-radio-group>
</div>

<!-- Buttons -->
<div class="mt-5">
    <button class="button bblg sm-100 my-3" (click)="confirm()">{{ data.confirm | translate}}</button>
    <button class="button bblg sm-100 my-3" (click)="close()" *ngIf="data.cancel">{{ data.cancel |
        translate}}</button>
</div>